module.exports = __webpack_public_path__ + "img/menuicon-105.2d1a2503.png";